import React, { useEffect, useState } from 'react';

// STYLES
import * as S from '../../../Establishment/ListEstablishment/styles';
import * as D from 'js/components/DesignSystem/styles';
import { AreaHeader, GoBack } from 'js/components/Configurations/CreateClub/styles';
import {
  Box,
  List,
  ListItem,
  ListItemText,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  CircularProgress,
} from '@mui/material';
import { BoxSearch, Input, InputBox, SearchIconButton } from './styles';

// ICONES
import { MdArrowBackIosNew } from 'react-icons/md';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import searchIcon from 'styles/assets/SearchUser/search.svg';

// COMPONENTES
import CustomButtonsTable from 'js/components/TriiboComponents/Tables/CustomButtonsTable';

// SERVICES
import { downloadImage, downloadImageAsBlob } from 'js/library/services/StorageManager';

export default function NotificationDetails(props) {
  const data = props.location.state;

  const [loading, setLoading] = useState(false);
  const [dataTable, setDataTable] = useState([]);

  const [searchTerm, setSearchTerm] = useState('');
  const [filteredResults, setFilteredResults] = useState([]);

  const [filePath, setFilePath] = useState('');
  const [downloadedFile, setDownloadedFile] = useState('');
  const [fileAsBlob, setFileAsBlob] = useState(null);
  const [fileContent, setFileContent] = useState('');

  // contém a informação se é estabelecimento ou clube
  const origin = localStorage.getItem('origin');

  const column = [
    { heading: origin === 'club' ? 'Chave do clube' : 'Celular do usuário', value: 'key' },
    { heading: 'Uid', value: 'uId' },
    { heading: 'Usuário que pode ver a notificação', value: 'name' },
  ];

  useEffect(() => {
    if (dataTable) {
      setFilteredResults(dataTable);
      setLoading(false);
    }
  }, [dataTable]);

  useEffect(() => {
    if (data.listUsersPath) {
      setFilePath(data.listUsersPath);
    }
  }, []);

  const splitIndex = filePath.lastIndexOf('/');
  const path = filePath.substring(0, splitIndex);
  const nameFile = filePath.substring(splitIndex + 1);

  // baixa o arquivo da pasta post-users-uid e transfoma em uma url
  useEffect(() => {
    if (nameFile) {
      downloadImage(path, nameFile)
        .then((downloaded) => {
          setDownloadedFile(downloaded);
        })
        .catch(() => {});
    }
  }, [nameFile]);

  // pega a url e transforma em um blob
  useEffect(() => {
    const download = async () => {
      if (downloadedFile.indexOf('https') === 0) {
        const fileblob = await downloadImageAsBlob(downloadedFile);
        setFileAsBlob(fileblob);
      }
    };
    download();
  }, [downloadedFile]);

  // pega o blob e extrai os dados do arquivo (.txt ou .csv)
  useEffect(() => {
    if (fileAsBlob) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setFileContent(e.target.result);
      };
      reader.readAsText(fileAsBlob);
    }
  }, [fileAsBlob]);

  // pega os dados extraídos e coloca dentro do state data
  useEffect(() => {
    if (fileContent) {
      setLoading(true);
      // divide o conteúdo do arquivo em linhas (caso haja várias linhas no arquivo)
      const lines = fileContent.trim().split('\n');

      // mapeia cada linha para criar um objeto
      lines.forEach((line) => {
        const [uId, key, name] = line.split(';');
        const newUserInfo = {
          uId: uId.trim() || 'N/A',
          key: 'N/A',
          name: 'N/A',
        };

        // adiciona ao state data
        setDataTable((prevData) => [...prevData, newUserInfo]);
      });
    }
  }, [fileContent]);

  // barra de pesquisa da tabela
  const handleSearch = (e) => {
    const term = e.target.value.trim();
    setSearchTerm(term);

    const filtered = dataTable.filter(
      (user) =>
        user.key?.includes(term) ||
        user.name?.toLowerCase().includes(term) ||
        user.uId?.toLowerCase().includes(term)
    );
    setFilteredResults(filtered);
  };

  const componentReceiver = () => {
    return {
      columnComponent: null,
      childrenComponent: null,
    };
  };

  return (
    <S.Container style={{ paddingBottom: '200px' }}>
      <AreaHeader
        style={{
          color: '#08bad0',
          justifyContent: 'end',
          padding: '1rem',
          marginLeft: '3rem',
        }}
      >
        <GoBack
          onClick={() => {
            window.history.back();
          }}
        >
          <MdArrowBackIosNew /> Voltar
        </GoBack>
      </AreaHeader>
      <D.TriiboH1
        style={{
          textAlign: 'center',
        }}
      >
        Detalhes da Notificação
      </D.TriiboH1>

      <Box sx={{ width: '100%', margin: 'auto' }}>
        <List>
          <ListItem sx={{ alignItems: 'flex-start', paddingBottom: '16px' }}>
            <ListItemText
              primary="Data e hora em que a notificação será disparada:"
              secondary={data.scheduleDate}
              sx={{ display: 'flex', alignItems: 'center' }}
              secondaryTypographyProps={{ sx: { paddingLeft: '10px', fontSize: '16px' } }}
            />
          </ListItem>
          <Divider />
          <ListItem sx={{ alignItems: 'flex-start', paddingBottom: '16px' }}>
            <ListItemText
              primary="Titulo:"
              secondary={data.notificationTitle}
              sx={{ display: 'flex', alignItems: 'center' }}
              secondaryTypographyProps={{ sx: { paddingLeft: '10px', fontSize: '16px' } }}
            />
          </ListItem>
          <Divider />
          <ListItem sx={{ alignItems: 'flex-start', paddingBottom: '16px' }}>
            <ListItemText
              primary="Mensagem:"
              secondary={data.notificationBody}
              sx={{
                display: 'flex',
                alignItems: 'center',
                paddingBottom: data.notificationBody.length > 100 ? '16px' : '0px',
              }}
              secondaryTypographyProps={{ sx: { paddingLeft: '10px', fontSize: '16px' } }}
            />
          </ListItem>
          <Divider />
          <ListItem sx={{ alignItems: 'flex-start', paddingBottom: '16px' }}>
            <ListItemText
              primary="Origem:"
              secondary={data.origin}
              sx={{ display: 'flex', alignItems: 'center' }}
              secondaryTypographyProps={{ sx: { paddingLeft: '10px', fontSize: '16px' } }}
            />
          </ListItem>
          <Divider />
        </List>
      </Box>

      {data.hasListUsers && data.listUsersPath !== false ? (
        <Box sx={{ width: '100%', margin: 'auto' }}>
          {dataTable.length > 0 && !loading ? (
            <>
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  Lista de usuários
                </AccordionSummary>
                <AccordionDetails>
                  <BoxSearch style={{ width: '100%', marginTop: '20px' }}>
                    <InputBox style={{ borderBottom: '1px solid #ccc' }}>
                      <Input
                        placeholder="Pesquisar usuário..."
                        onChange={handleSearch}
                        value={searchTerm}
                      />
                      <SearchIconButton onClick={(e) => e.preventDefault()}>
                        <img src={searchIcon} alt="" />
                      </SearchIconButton>
                    </InputBox>
                  </BoxSearch>

                  {filteredResults.length > 0 ? (
                    <Box sx={{ marginTop: '20px' }}>
                      <CustomButtonsTable
                        data={filteredResults}
                        column={column}
                        perPage={10}
                        componentReceiver={componentReceiver}
                        loadingTableDisabled={true}
                      />
                    </Box>
                  ) : (
                    <Box sx={{ display: 'flex', justifyContent: 'center', margin: '40px 0px' }}>
                      <strong>Nenhum resultado encontrado.</strong>
                    </Box>
                  )}
                </AccordionDetails>
              </Accordion>
            </>
          ) : (
            <Box sx={{ display: 'flex', justifyContent: 'center', margin: '40px 0px' }}>
              <CircularProgress />
            </Box>
          )}
        </Box>
      ) : data.hasListUsers && data.listUsersPath === false ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', margin: '40px 0px' }}>
          <strong>
            O arquivo contendo a lista de usuários notificados não foi encontrado ou está
            corrompido.
          </strong>
        </Box>
      ) : null}
    </S.Container>
  );
}
